import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import DataHelper, { DataHelperConfiguration } from "@Scripts/Common/DataHelper";
import FormHelper from "@Scripts/Common/FormHelper";
import { Watch } from "vue-property-decorator";

@Component({ name: "ModuleDeviceTelemetry" })
export default class ModuleDeviceTelemetry extends Vue {
    public realTimeData: any = null;
    public validationErrors: any[] = [];
    public realTimeNav: string = null;
    public realTimeDataInterval: any = null;
    public dataConfiguration: DataHelperConfiguration = { culture: (<any>window).App.userCulture };

    get navigationContext(): any {
        return this.$store.getters["navigationStore/navigationContext"];
    }

    get itemIdMaster() {
        return this.$store.getters["itemStore/itemIdMaster"];
    }

    @Watch("navigationContext") onPropertyChanged(value: any, oldValue: any) {
        this.getData();
    }

    public async created() {
        await this.getData();

        this.setRealTimeDataInterval();
    }

    public async getData() {
        this.validationErrors = [];

        try {
            let response = await Axios.post("/dataweb/api/module/moduledevicetelemetry/getdata?nav=" + this.navigationContext.nav);

            this.realTimeData = response.data.realTimeData;
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public setRealTimeDataInterval() {
        this.realTimeNav = this.navigationContext.nav;
        const interval = 5 * 1000; // 5 seconds
        let vm = this;
        this.realTimeDataInterval = setInterval(function () {
            if (vm.navigationContext.nav != vm.realTimeNav) {
                clearInterval(vm.realTimeDataInterval);
            } else {
                vm.getData();
            }
        }, interval);
    }

    public getModuleData() {
        let moduleData = { isCompleted: true };
        return moduleData;
    }

    public formatDateTimeOffset(dateItem: string): string {
        if (dateItem == null) {
            return "";
        }

        let date = new Date(dateItem);
        return date.toLocaleString((<any>window).App.userCulture, {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit"
        });
    }

    public formatSeconds(seconds: number): string {
        let hours: any = Math.floor(seconds / 3600);
        let minutes: any = Math.floor((seconds - (hours * 3600)) / 60);

        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        return hours + ':' + minutes;
    }
};